import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        right: "50%",
      }}
    >
      <div
        style={{ width: "3rem", height: "3rem" }}
        className="spinner-border text-primary"
      ></div>
    </div>
  );
}

export default LoadingSpinner;